import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import TableSkeleton from '../../../../components/SkeletonLoader/TableSkeleton';
import HeaderToolbarContent from '../../../../components/TimeOnTaskReport/HeaderToolbar';
import { ResourceUtils } from '../../../assignments/components/questionDetailComponents/ResourceUtils';
import { useReportContext } from '../../components/reportContext';
import { useGetLoginActivityReportMutation } from '../../../../features/authentication/reportApiSlice';
import { selectFerpaState } from '../../../../features/authentication/authSlice';
import { selectCurrentToken } from '../../../../features/authentication/authSlice';
import CustomToast from '../../../../components/Toast';
import appConfig from '../../../../app-config';
import SortButtons from '../../../../../src/components/SortButtons/index';

const LoginActivityReport = () => {
  const { assignmentId, selectedClassId, selectedStudentId, setSelectedStudentId, studentToIncludeTab, startDate, setStartDate, endDate, setEndDate, setStudentName } = useReportContext();
  const baseUrl = appConfig.apiBaseUrl;
  const [sortId, setSortId] = useState('studentName');
  const [isAscending, setIsAscending] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [reportDetails, setReportDetails] = useState([]);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const accessToken = useSelector(selectCurrentToken);
  const [getLoginActivityReport] = useGetLoginActivityReportMutation();
  const navigate = useNavigate();
  const ferpaEnabled = useSelector(selectFerpaState);

  useEffect(() => {
    getLoginActivityReportAsync();
  }, []);

  const getLoginActivityReportAsync = async () => {
    setIsLoading(true);
    let studentId = 0;
    if(studentToIncludeTab == 2)
      studentId = selectedStudentId;
    else if( studentToIncludeTab == 0)
      studentId = -1;
    const option = {
      studentId: studentId,
      classId: selectedClassId,
      assignmentId: assignmentId
    };
    var response = await getLoginActivityReport(option);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Description, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      setStartDate(response.data.startDate);
      setEndDate(response.data.endDate);
      setReportDetails(response.data.reportDetails);
    }
    setIsLoading(false);
  };

  const handleSort = async (currentSortId) => {
    let sortAsc = true;
    if (currentSortId === sortId)
      sortAsc = !isAscending;
    setSortId(currentSortId);

    let sortedStudents = await ResourceUtils.customSort(reportDetails, currentSortId, sortAsc);
    setReportDetails(sortedStudents);
    setIsAscending(sortAsc);
  };

  const handlePrintPdf = async () => {
    setIsDownloading(true);
    const contentWrapper = document.getElementById('content');
    const contentClone = contentWrapper.cloneNode(true);

    const header1 = document.createElement('header');
    header1.textContent = 'Login Activity Report';
    header1.style.fontWeight = 'bold';
    header1.style.fontSize = '16px';
    contentClone.insertBefore(header1, contentClone.firstChild);
    const base64Encoded = btoa(unescape(encodeURIComponent(contentClone.innerHTML)));

    fetch(`${baseUrl}/PdfGenerator`, {
      method: 'POST',
      body: JSON.stringify({
        htmlContent: base64Encoded,
        OutputFileName: 'QuestionPreview'
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.type === 'application/pdf') {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          const fileName = 'LoginActivityReport.pdf';
          link.download = fileName;
          link.href = url;
          link.click();
          URL.revokeObjectURL(url);
        } else {
          CustomToast('Error ocuurred while generating pdf.', 'error');
        }
        setIsDownloading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsDownloading(false);
      });
  };

  const NavigateToTimeOnTask = (studentId, studentName) => {
    setSelectedStudentId(studentId);
    setStudentName(studentName);
    navigate('timeontask-report');
  };

  return (
    <>
      <div className='white-card'>
        <HeaderToolbarContent
          reportTitle='Login Activity Report'
          printHandler={handlePrintPdf}
          isExporting={false}
          isDownloading={isDownloading}
          hideClassDropdown={true}
          backButtonOnClick={() => window.history.back()}
        />
        <div id='content'>
          <div className='mb-4 mt-4'>Report from <strong>{startDate}</strong> to <strong>{endDate}</strong></div>
          <div className='custom-table'>
            <table className='table reportTable'>
              {reportDetails.length > 0 && !isLoading ? (
                <>
                  <thead className='thead-light align-middle'>
                    <tr>
                      <th scope="col" className='fw-medium text-center' onClick={() => handleSort('studentName')}>
                      Student
                        <SortButtons
                          selectedSortId={sortId}
                          elementSortId={'studentName'}
                          isAscending={isAscending}
                        />
                      </th>
                      {studentToIncludeTab == 1 && selectedClassId == -1 &&
                      <th scope="col" className='fw-medium text-center' onClick={() => handleSort('className')}>
                        Class
                        <SortButtons
                          selectedSortId={sortId}
                          elementSortId={'className'}
                          isAscending={isAscending}
                        />
                      </th>
                      }
                      <th scope="col" className='fw-medium text-center' onClick={() => handleSort('onlineTime')}>
                      Online Time Days <span className='fs-7 fw-normal'>(HH:MM:SS)</span>
                        <SortButtons
                          selectedSortId={sortId}
                          elementSortId={'onlineTime'}
                          isAscending={isAscending}
                        />
                      </th>
                      <th scope="col" className='fw-medium text-center' onClick={() => handleSort('idleTime')}>
                      Idle Time Days <span className='fs-7 fw-normal'>(HH:MM:SS)</span>
                        <SortButtons
                          selectedSortId={sortId}
                          elementSortId={'idleTime'}
                          isAscending={isAscending}
                        />
                      </th>
                      <th scope="col" className='fw-medium text-center' onClick={() => handleSort('activeTime')}>
                      Active Time Days <span className='fs-7 fw-normal'>(HH:MM:SS)</span>
                        <SortButtons
                          selectedSortId={sortId}
                          elementSortId={'activeTime'}
                          isAscending={isAscending}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportDetails?.map((item, index) => (
                      <>
                        <tr key={index}>
                          <td className='text-center'><strong className='cursor-pointer text-decoration-underline' onClick={() => NavigateToTimeOnTask(item.studentId, item.studentName)}>{ferpaEnabled ? item.studentName : 'name hidden'}</strong></td>
                          {studentToIncludeTab == 1 && selectedClassId == -1 &&
                          <td className={`text-center ${item.className == 'Multiple Classes' ? 'fw-bold' : ''}`}>{item.className}</td>
                          }
                          <td className='text-center text-info'>{item.onlineTime}</td>
                          <td className='text-center text-danger'>{item.idleTime}</td>
                          <td className='text-center text-active'>{item.activeTime}</td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </>
              ) : isLoading ? (
                <>
                  <TableSkeleton
                    colCount={5}
                    rowCount={4}
                  />
                </>
              ) :
                <p className='text-danger'>No Activity Report Found.</p>
              }
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginActivityReport;